import React, { useEffect, useState } from 'react'
import { Looks4 } from '@mui/icons-material'
import { Box } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { SubscriptionDetails } from 'types/api/faber/dataUsage.type'

export default function JetpacSubscriptionCard({
  subscriptionData
}: { subscriptionData: SubscriptionDetails[] }) {

  const [isSubscriptionActive, setIsSubscriptionActive] = useState(false)
  const [activeSubscriptionName, setActiveSubscriptionName] = useState("")

  useEffect(() => {
    if (!subscriptionData) {
      setIsSubscriptionActive(false)
    } else {
      subscriptionData.forEach(subscription => {
        // Only care for active subscriptions
        if (subscription.status == "active") {
          setIsSubscriptionActive(true)
          setActiveSubscriptionName(subscription.name)
        }
      });
    }
  }, [subscriptionData])

  return (
    <>
      <Box
        sx={{
          width: '80px',
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: circlesOrbitColorPalette.success.main,
          position: 'absolute',
          ml: '9rem',
          borderRadius: '50%',
          mt: '-70px'
        }}
      >
        <Looks4 sx={{ fontSize: '40px', color: 'white' }} />
      </Box>

      <NormalText
        isBold
        textAlign={'left'}
        sx={{
          fontSize: '24px',
          fontWeight: '700px',
          m: 0
        }}
        text={'Jetpac Subscription'}
      />

      <TextColorFontBody
        sx={{
          fontSize: '14px',
          lineHeight: 1,
          color: '#7B8794',
          textAlign: 'left',
          mt: '10px'
        }}
      >
        {isSubscriptionActive ? activeSubscriptionName : "No Jetpac subscription"}
      </TextColorFontBody>
    </>
  )
}
